import expiredSession from './expired-session.json';

export default {
  'session-status': {
    ...expiredSession,
  },
};
